// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="../dist/gui.d.ts" />

// import { gsap, TweenLite } from "../node_modules/gsap";
export default class TestAnimationJitter {

    public constructor(app: vf.Application, uiStage: vf.gui.Stage) {
        this.onLoad(app, uiStage)
    }


    private onLoad(app: vf.Application, uiStage: vf.gui.Stage) {

        // const ellipse = new vf.gui.Ellipse();
        // ellipse.lineType = "dash";
        // ellipse.x = 200;
        // ellipse.y = 300;
        // ellipse.lineColor = 0xff00cc;
        // ellipse.lineWidth = 3;
        // ellipse.width = 500;
        // ellipse.height = 300;
        // uiStage.addChild(ellipse);


        const la = new vf.gui.Label("抖一抖2");

        la.style.backgroundColor = 0x00ff00;
        la.x = 300;
        la.width = 200;
        la.top = 300;
        // la.pivotX = 100;
        uiStage.addChild(la);

        // new vf.gui.Tween(la)
        //     .to({ x: 500 }, 1000)
        //     .start();
        // new vf.gui.Tween(la)
        //     .delay(1000)
        //     .to({ y: 500 }, 1000)
        //     .start();

        const l1a = new vf.gui.Label("抖一抖1");

        l1a.style.backgroundColor = 0x00ff00;
        l1a.x = 300;
        l1a.width = 200;
        l1a.height = 30;
        l1a.top = 300;
        // l1a.y = 100;
        l1a.pivotX = 100;
        // l1a.pivotY = 15;
        uiStage.addChild(l1a);


        vf.gui.Animation.play("jitter", l1a, { rotation: 3, vertical: 5 }, 1000, this.callBack.bind(this));
        // var test = new vf.gui.Tween(l1a);
        // test.to({ x: 300 }, 2000)
        //     .easing(vf.gui.Easing.Linear.None)
        //     .yoyo(true)
        //     .start();

        // TweenLite.to(l1a, { x: 300 }, 1)
        // TweenLite.to(l1a, { y: 300 }, 1)

        // var t = vf.gui.Tween;
        // t.to(l1a, { x: 300 }, 1000);
        // t.to(l1a, { y: 300 }, 1000).play();


        // var t2 = new gsap.timeline({ repeat: -1, repeatDelay: 0, align: "normal", paused: true })
        // t2.add(TweenLite.to(l1a, {
        //     delay: 0,
        //     duration: 1,
        //     x: 300,
        //     repeat: 5,
        //     onComplete: () => {
        //         console.log('completed');
        //     }
        // }))

        //     .add(TweenLite.to(l1a, {
        //         delay: 0,
        //         duration: 1,
        //         y: 300,
        //         onComplete: () => {
        //             console.log('completed');
        //         }
        //     }))
        //     .addPause(5)
        //     .play();
        // var t1 = new gsap.timeline({ tweens: [t2], repeat: 5, repeatDelay: 0 })
        // t1.add(TweenLite.to(l1a, {
        //     delay: 0,
        //     duration: 1,
        //     x: 300,
        //     onComplete: () => {
        //         console.log('completed');
        //     }
        // }));



        // .to(l1a, {
        //     delay: 0,
        //     duration: 1,
        //     y: 500,
        //     onComplete: () => {
        //         console.log('completed X');
        //     }
        // }, 1)

        // t1.play();
        // t1.reversed(true);
        // t1.play();

        // let jitter1 = new vf.gui.AnimationJitter(l1a, { rotation: 3, vertical: 310 }, 2000);
        // jitter1.play();




        // const jitter = new vf.gui.timelin(la, false)
        //     .to(tweeem, { vertical: 300 }, 1000)
        //     .to(tweeem, { vertical: 300 }, 1000)
        //     .to(tweeem, { vertical: 300 }, 1000)
        //     .addDelay(2000)
        //     .to(vf.gui.AnimationJitter, { horizontal: 400 }, 3000)
        // play.();

        // const jitter3 = new vf.gui.AnimationLine(l1a)
        // .add(vf.gui.AnimationJitter, { horizontal: 400 }, 1000)
        // .add(vf.gui.AnimationJitter, { rotation: 300 }, 1000)
        // .add(vf.gui.AnimationJitter, { vertical: 300 }, 1000)
        // .play();

        const time = 100;
        this.getButton('抖动', () => {
            //动画---抖动
            vf.gui.Animation.play("jitter", l1a, { rotation: 3, vertical: 5 }, 1000, this.callBack.bind(this));
            // t2.resume();
            // test.reverse();
            // t2.to(l1a, {
            //     delay: 0,
            //     duration: 1,
            //     y: 500,
            //     onComplete: () => {
            //         console.log('completed Y');
            //     }
            // })
            // t1.add(TweenLite.to(l1a, {
            //     delay: 0,
            //     duration: 1,
            //     width: 500,
            //     onComplete: () => {
            //         console.log('completed');
            //     }
            // }));
            // t1.reverse();
            // t1.seek(1.5);
            // jitter.options = { vertical: 10 };
            // jitter.play(1000);
            // jitter1.gotoAndPlay(0);
            // time += 100;
        }, uiStage, 15, 0);

        // this.getButton('水平', () => {
        //     // jitter.options = { horizontal: 10 };
        //     // jitter.play(1000);
        //     jitter1.pause();
        // }, uiStage, 15, 0);

        // this.getButton('角度抖动', () => {
        //     // jitter.options = { rotation: 3 };
        //     // jitter.play(1000);
        //     jitter1.play();
        // }, uiStage, 15, 0);

    }

    private callBack() {
        console.log("sssssssss");
    }

    private posY = 15;
    private getButton(title: string, fun: Function, target: any, x: number, y: number) {
        const button = new vf.gui.Label;
        button.style.fontSize = 24;
        button.style.fontFamily = 'PingFang-SC-Medium,PingFang-S';
        button.style.fontWeight = 500;
        button.style.color = 0xffffff;
        button.style.lineHeight = 45;
        button.text = title;
        button.interactabled = true;
        button.x = x;
        button.y = this.posY;
        button.on(vf.gui.Interaction.TouchMouseEvent.onClick, fun);
        target.addChild(button);
        this.posY = this.posY + 25 + y;
    }
}

